if (!customElements.get('getfly-size-shop')) {
  class GetFlySizeShop extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.selected = new Set(); this.group = ['kids','women'].includes(this.dataset.initialGroup) ? this.dataset.initialGroup : 'men'; this.category = new URL(location.href).searchParams.get('category') || 'all'; this.limit = 24;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency});
      this.addEventListener('click', event => {
        const button = event.target.closest('button'); if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-retry')) { this.load(); return; }
        if (button.hasAttribute('data-load')) { const previous = this.limit; this.limit += 24; this.render(); this.querySelectorAll('.gfs__product')[previous]?.focus(); return; }
        if (button.dataset.group) {
          if (this.group === button.dataset.group) return;
          this.group = button.dataset.group; this.selected.clear(); this.category = 'all'; this.limit = 24; this.load(); return;
        }
        if (button.dataset.size) { const size = button.dataset.size; this.selected.has(size) ? this.selected.delete(size) : this.selected.add(size); }
        if (button.dataset.category) this.category = button.dataset.category;
        if (button.hasAttribute('data-clear')) { this.selected.clear(); this.category = 'all'; }
        this.limit = 24; this.render();
      });
      this.querySelector('[data-sort]').addEventListener('change', () => {this.limit = 24; this.render();});
      this.observer = new IntersectionObserver(entries => {if(entries.some(e => e.isIntersecting)){this.observer.disconnect(); this.load();}}, {rootMargin:'300px'});
      this.observer.observe(this);
      this.render();
    }
    disconnectedCallback() {this.observer?.disconnect(); this.abort?.abort();}
    normalize(value, bottom = false) {
      const raw = String(value).trim().toUpperCase().replace(/[\s_-]+/g,'');
      const waist = raw.match(/^(?:SIZE|WAIST|W)?(\d{2})(?:["”]|IN(?:CH(?:ES)?)?)?(?:(?:[X×/](?:L)?|L)\d{2})?$/);
      if (bottom && waist && Number(waist[1]) >= 24 && Number(waist[1]) <= 70) return {size:'W'+Number(waist[1])};
      const clean = raw.replace(/\((?:X{1,5}L?|[2-5]XL?|X{1,5}LARGE)\)/g,'').replace(/SET$/,'');
      const s = clean.replace(/EXTRASMALL/g,'XS').replace(/EXTRALARGE/g,'XL').replace(/SMALL/g,'S').replace(/MEDIUM/g,'M').replace(/LARGE/g,'L').replace(/TALL|BIG/g,'').replace(/(?:T|B)$/,'');
      const aliases = {'XXS':'XXS','XS':'XS','S':'S','M':'M','L':'L','XL':'XL','XXL':'2X','2XL':'2X','2X':'2X','XXXL':'3X','3XL':'3X','3X':'3X','XXXXL':'4X','4XL':'4X','4X':'4X','XXXXXL':'5X','5XL':'5X','5X':'5X','1X':'XL'};
      return {size:aliases[s] || null};
    }
    menSize(value, bottom) {
      const label = String(value).trim().replace(/\s+/g,' ');
      const direct = this.normalize(label,bottom).size;
      if (direct) return {sizes:[direct],label};
      if (/^ONE\s*SIZE(?:\s*FITS\s*ALL)?$/i.test(label)) return {sizes:['M:ONE'],label};
      const pieces = label.split(/\+/).map(part=>part.replace(/\b(?:T-?SHIRT|SHIRT|TEE|SHORTS|ONLY|SET)\b/ig,'').trim());
      const parsed = pieces.map(part=>this.normalize(part,bottom).size);
      if (parsed.length && parsed.every(size=>size && size===parsed[0])) return {sizes:[parsed[0]],label};
      return {sizes:label ? ['M:'+label.toUpperCase()] : [],label};
    }
    kidsSize(value) {
      const label = String(value).trim().replace(/\s+/g,' ');
      const raw = label.toUpperCase().replace(/\s+/g,'');
      if (/^ONE\s*SIZE(?:FITSALL)?$/.test(raw)) return {sizes:['K:ONE'],label};
      if (/^[2-5]T$/.test(raw)) return {sizes:['K:'+raw],label};
      const age = raw.match(/^(\d{1,2})(?:A|Y|YR|YRS|YEARS)?$/);
      if (age && Number(age[1]) >= 6) return {sizes:['K:'+Number(age[1])],label};
      const range = raw.match(/\((\d{1,2})(?:[-–/](\d{1,2}))?\)/) || raw.match(/^(\d{1,2})[-–/](\d{1,2})(?:A|Y|YRS)?$/);
      if (range) {
        const low = Number(range[1]), high = Number(range[2] || range[1]);
        const sizes = [6,8,10,12,14,16].filter(n=>n>=low&&n<=high).map(n=>'K:'+n);
        if(sizes.length)return {sizes,label};
      }
      return {sizes:label ? ['K:'+raw] : [],label};
    }
    womenSize(value) {
      const label = String(value).trim().replace(/\s+/g,' ');
      const raw = label.toUpperCase().replace(/[\s_-]+/g,'');
      if (/^ONESIZE(?:FITSALL)?$/.test(raw)) return {sizes:['F:ONE'],label};
      const base = label.replace(/\((?:[2-5]X(?:L)?)\)/ig,'').trim();
      const size = this.normalize(base).size;
      return {sizes:label ? [size || 'F:'+raw] : [],label};
    }
    async fetchPage(page, source, signal) {
      const url = new URL(source, document.baseURI);
      url.searchParams.set('view','getfly-size-data'); url.searchParams.set('page',String(page));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      const response = await fetch(url,{signal,cache:'no-store',credentials:'same-origin'});
      if (!response.ok) throw new Error('Inventory unavailable');
      return response.json();
    }
    async load() {
      this.abort?.abort(); this.abort = new AbortController(); this.products = null;
      const request = this.abort;
      const group = this.group;
      const source = group === 'kids' ? this.dataset.kidsSource : group === 'women' ? this.dataset.womenSource : this.dataset.source;
      this.querySelector('[data-products]').replaceChildren();
      this.querySelector('[data-special-sizes]').replaceChildren();
      this.querySelector('[data-extra-sizes]').replaceChildren();
      this.querySelector('[data-extra-group]').hidden = true;
      this.querySelector('[data-special-categories]').replaceChildren();
      this.querySelector('[data-waist-group]').hidden = true;
      this.querySelector('[data-load]').hidden = true;
      this.querySelectorAll('[data-count]').forEach(el=>{el.textContent='—';});
      this.render();
      this.querySelector('[data-status]').textContent = this.strings.loading;
      this.querySelector('[data-retry]').hidden = true;
      this.querySelector('[data-products]').setAttribute('aria-busy','true');
      try {
        const first = await this.fetchPage(1,source,request.signal);
        if (first.total > 25000) throw new Error('Catalog exceeds pagination limit');
        const products = [...first.products];
        for (let page = 2; page <= first.pages; page += 3) {
          const pages = await Promise.all(Array.from({length:Math.min(3,first.pages-page+1)},(_,i)=>this.fetchPage(page+i,source,request.signal)));
          pages.forEach(batch=>products.push(...batch.products));
        }
        if (request.signal.aborted || request !== this.abort) return;
        this.products = [...new Map(products.map(p=>[p.id,p])).values()].filter(p=>!this.dataset.collectionScope || p.collections.includes(this.dataset.collectionScope)).map(p=>{
          const bottom = p.collections.some(c=>['pants','jeans','shorts'].includes(c));
          const categories = group !== 'men' ? ['type:'+String(p.type || '').trim().toLowerCase()].filter(c=>c!=='type:') : p.collections;
          return {...p,categories,variants:p.variants.filter(v=>v.price>0).map(v=>({...v,...(group === 'kids' ? this.kidsSize(v.size) : group === 'women' ? this.womenSize(v.size) : this.menSize(v.size,bottom))})).filter(v=>v.sizes.length)};
        }).filter(p=>p.variants.length);
        this.querySelector('[data-men-extra]')?.remove();
        if (group === 'men') {
          const primary = new Set([...this.querySelectorAll('[data-regular-sizes] [data-size]')].map(b=>b.dataset.size));
          const extras = [...new Map(this.products.flatMap(p=>p.variants.flatMap(v=>v.sizes.filter(s=>!primary.has(s)&&!/^W\d+$/.test(s)).map(s=>[s,s==='M:ONE'?this.strings.one_size:v.label])))).entries()].sort((a,b)=>a[1].localeCompare(b[1],undefined,{numeric:true}));
          const root=document.createElement('div');root.dataset.menExtra='';root.className='gfs__sizes';
          for(const [size,label] of extras){const b=document.createElement('button');b.type='button';b.dataset.size=size;b.textContent=label;b.setAttribute('aria-pressed','false');root.append(b);}
          this.querySelector('[data-regular-sizes]').append(root);
        }
        const specialRoot = this.querySelector('[data-special-sizes]');
        if (group !== 'men') {
          const primary = group === 'kids' ? ['2T','3T','4T','5T','6','8','10','12','14','16','ONE'].map(s=>['K:'+s,s==='ONE'?this.strings.one_size:s]) : ['XS','S','M','L','XL','2X','3X','4X','5X'].map(s=>[s,s]);
          const keys = new Set(primary.map(([size])=>size));
          const extras = [...new Map(this.products.flatMap(p=>p.variants.flatMap(v=>v.sizes.filter(size=>!keys.has(size)).map(size=>[size,size==='F:ONE'?this.strings.one_size:v.label])))).entries()].sort((a,b)=>a[1].localeCompare(b[1],undefined,{numeric:true}));
          for (const [size,label] of [...primary,...extras]) {const button=document.createElement('button');button.type='button';button.dataset.size=size;button.textContent=label;button.setAttribute('aria-pressed','false');(keys.has(size)?specialRoot:this.querySelector('[data-extra-sizes]')).append(button);}
          this.querySelector('[data-extra-group]').hidden = !extras.length;
          const categories = [...new Set(this.products.flatMap(p=>p.categories))].sort();
          for (const category of categories) {
            const button=document.createElement('button');button.type='button';button.dataset.category=category;button.setAttribute('aria-pressed','false');
            const label=document.createElement('span');const type=category.slice(5);label.textContent=this.strings.kids_categories[type] || this.products.find(p=>p.categories.includes(category)).type;
            const count=document.createElement('span');count.dataset.count=category;count.textContent='—';button.append(label,count);this.querySelector('[data-special-categories]').append(button);
          }
        }
        const waistSizes = [...new Set(this.products.flatMap(p=>p.variants.flatMap(v=>v.sizes)).filter(s=>/^W\d+$/.test(s)))].sort((a,b)=>Number(a.slice(1))-Number(b.slice(1)));
        const waistRoot = this.querySelector('[data-waist-sizes]');waistRoot.replaceChildren();
        for (const size of waistSizes) {const button=document.createElement('button');button.type='button';button.dataset.size=size;button.textContent=size.slice(1);button.setAttribute('aria-pressed','false');waistRoot.append(button);}
        this.querySelector('[data-waist-group]').hidden = group !== 'men' || !waistSizes.length;
        this.render();
      } catch(error) {
        if (error.name === 'AbortError' || request !== this.abort) return;
        this.querySelector('[data-status]').textContent = this.strings.error;
        this.querySelector('[data-products]').replaceChildren();
        this.querySelector('[data-load]').hidden = true;
        this.querySelector('[data-retry]').hidden = false;
      } finally {if(request === this.abort)this.querySelector('[data-products]').setAttribute('aria-busy','false');}
    }
    inGroup() {return true;}
    matches(product, sizes = true) {return product.variants.filter(v=>this.inGroup(v) && (!sizes || !this.selected.size || v.sizes.some(s=>this.selected.has(s))));}
    render() {
      const kids = this.group === 'kids';
      const special = this.group !== 'men';
      this.querySelector('[data-regular-sizes]').hidden = special;
      this.querySelector('[data-special-size-group]').hidden = !special;
      this.querySelector('[data-special-label]').textContent = kids ? this.strings.kids_sizes : this.strings.women_sizes;
      this.querySelector('[data-special-note]').textContent = kids ? this.strings.kids_note : this.strings.women_note;
      this.querySelector('[data-regular-categories]').hidden = special;
      this.querySelector('[data-special-categories]').hidden = !special;
      this.querySelector('[data-all-label]').textContent = this.dataset.collectionTitle || (kids ? this.strings.kids_all : special ? this.strings.women_all : this.strings.all);
      this.querySelectorAll('[data-group]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group === this.group)));
      this.querySelectorAll('[data-size]').forEach(b=>{b.setAttribute('aria-pressed',String(this.selected.has(b.dataset.size)));});
      this.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category === this.category)));
      if (!this.products) return;
      const base = this.products.filter(p=>this.matches(p).length);
      this.querySelectorAll('[data-count]').forEach(el=>{el.textContent=String(el.dataset.count === 'all' ? base.length : base.filter(p=>p.categories.includes(el.dataset.count)).length);});
      this.querySelectorAll('[data-size]').forEach(b=>{const exists=this.products.some(p=>(this.category==='all'||p.categories.includes(this.category))&&p.variants.some(v=>this.inGroup(v)&&v.sizes.includes(b.dataset.size))); b.disabled=!exists&&!this.selected.has(b.dataset.size);});
      let result=base.filter(p=>this.category==='all'||p.categories.includes(this.category)).map(p=>({...p,matching:this.matches(p)}));
      const price=p=>Math.min(...p.matching.map(v=>v.price));
      const sort=this.querySelector('[data-sort]').value;
      if(sort==='low') result.sort((a,b)=>price(a)-price(b));
      if(sort==='high') result.sort((a,b)=>price(b)-price(a));
      if(sort==='name') result.sort((a,b)=>a.title.localeCompare(b.title));
      const root=this.querySelector('[data-products]');root.replaceChildren();
      for(const p of result.slice(0,this.limit)) {
        const link=document.createElement('a');link.className='gfs__product';
        const variant=p.matching.reduce((best,candidate)=>candidate.price<best.price?candidate:best);
        const u=new URL(p.url,document.baseURI);u.searchParams.set('variant',String(variant.id));
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);link.href=u.pathname+u.search;
        if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.width=480;img.height=600;img.loading='lazy';link.append(img);}
        const title=document.createElement('h3');title.textContent=p.title;
        const money=document.createElement('p');money.textContent=this.money.format(price(p)/100);
        const sizes=document.createElement('small');sizes.textContent=this.strings.stock+': '+[...new Set(p.matching.map(v=>v.label))].join(', ');
        link.append(title,money,sizes);root.append(link);
      }
      this.querySelector('[data-status]').textContent=result.length ? result.length+' '+(result.length===1?this.strings.result_one:this.strings.results) : this.strings.empty;
      this.querySelector('[data-load]').hidden=result.length<=this.limit;
    }
  }
  customElements.define('getfly-size-shop',GetFlySizeShop);
}




